import type React from "react";

interface Props {
  size?: number;
  color?: string;
}

export function WholeIcon(props: Props): React.ReactNode {
  const { size = 24, ...rest } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <title>Whole</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.23621C6.762 3.23621 2.5 7.32773 2.5 12.3562C2.5 17.3847 6.762 21.4762 12 21.4762C17.238 21.4762 21.5 17.3847 21.5 12.3562C21.5 7.32773 17.238 3.23621 12 3.23621Z"
        fill="currentColor"
      />
    </svg>
  );
}
